const uranusQuiz = [ 
    {
    question: "Uranus adalah planet ke berapa dari Matahari?",
    options: ["6", "7", "8", "9"],
    answer: 1,
  },
  {
    question: "Apa keunikan utama planet Uranus?",
    options: [
      "Memiliki cincin terbesar",
      "Berwarna merah",
      "Berotasi menyamping",
      "Paling dekat dengan Matahari",
    ],
    answer: 2,
  },
  {
    question: "Uranus termasuk jenis planet apa?",
    options: [
      "Planet terestrial",
      "Planet raksasa gas",
      "Planet es",
      "Planet kecil",
    ],
    answer: 2,
  },
  {
    question: "Warna dominan Uranus adalah?",
    options: [
      "Merah",
      "Hijau",
      "Biru kehijauan",
      "Kuning",
    ],
    answer: 2,
  },
  {
    question: "Mengapa Uranus terlihat berwarna biru kehijauan?",
    options: [
      "Karena lautan",
      "Karena gas metana di atmosfer",
      "Karena debu es",
      "Karena cahaya Matahari",
    ],
    answer: 1,
  },
  {
    question: "Berapa jumlah bulan yang dimiliki Uranus?",
    options: ["5", "13", "27", "50"],
    answer: 2,
  },
  {
    question: "Apakah Uranus memiliki cincin?",
    options: [
      "Tidak",
      "Ya, tipis dan gelap",
      "Ya, besar dan terang",
      "Hanya satu cincin",
    ],
    answer: 1,
  },
  {
    question: "Suhu rata-rata Uranus adalah?",
    options: [
      "Sangat panas",
      "Sedang",
      "Sangat dingin",
      "Sama seperti Bumi",
    ],
    answer: 2,
  },
  {
    question: "Waktu revolusi Uranus mengelilingi Matahari adalah?",
    options: [
      "29 tahun",
      "60 tahun",
      "84 tahun",
      "165 tahun",
    ],
    answer: 2,
  },
  {
    question: "Mengapa Uranus jarang diteliti langsung?",
    options: [
      "Karena terlalu kecil",
      "Karena terlalu panas",
      "Karena sangat jauh dan dingin",
      "Karena tidak menarik",
    ],
    answer: 2,
  },
]

export default uranusQuiz;